import styled from 'styled-components';

export const Iframe = styled.iframe`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;
